export const AdminActivityDashboards = {
  AdminActivityDashboards: 
  {
    permissionsId:'5d5d4956-0dd5-494c-7973-08dcaf947ea8',
    permissionsName:'Admin Activity' , 
    componentsId:null,
    components:null
  }
} ;
